<ng-container [ngSwitch]="component">
  <div *ngSwitchCase="'div'" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
  <h1 *ngSwitchCase="'h1'" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h1>
  <h2 *ngSwitchCase="'h2'" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h2>
  <h3 *ngSwitchCase="'h3'" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h3>
  <h4 *ngSwitchCase="'h4'" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h4>
  <h5 *ngSwitchCase="'h5'" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h5>
  <h6 *ngSwitchCase="'h6'" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h6>
  <p *ngSwitchCase="'p'" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </p>
  <label *ngSwitchCase="'label'" [for]="for" [ngClass]="className">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </label>
  <span *ngSwitchCase="'span'" [ngClass]="className"
    ><ng-container *ngTemplateOutlet="content"></ng-container
  ></span>
  <sup *ngSwitchCase="'sup'" [ngClass]="className"
    ><ng-container *ngTemplateOutlet="content"></ng-container
  ></sup>
  <a *ngSwitchCase="'anchor'" [ngClass]="className" (click)="handleClick()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-template #content><ng-content></ng-content></ng-template>
